var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading85_container"},[_c('span',{staticClass:"loader"})])
}]

export { render, staticRenderFns }